import * as React from 'react';

import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const commonHeaderStyle = {
  backgroundColor: '#F9F9F9',
  fontWeight: 'bold',
  borderBottom: '2px solid #b3b3b3'
}

function Row(props) {
  const [open, setOpen] = React.useState(props?.allOpened || false);

  const headColumns = props.headColumns;
  const bodyColumns = props.bodyColumns;
  const bodyData = props.bodyData;

  function renderBodyTableCellHeader(item, index) {
    const { field } = item;
    const title = props?.[field];

    return (
      <TableCell index={index} align="left">{title || ""}</TableCell>
    )
  }

  function renderColumnsTableCellBody(item, index) {
    return (
      <TableCell
        index={index}
        align="right"
        sx={{
          backgroundColor: '#F9F9F9',
          fontWeight: 'bold',
        }}
      >
        {item?.title || ""}
      </TableCell>
    )
  }

  function renderBodyTableCellBody(item, _) {
    return (
      <TableRow key={item.id}>
        {bodyColumns.map((columns, index) => {
          const { field } = columns;
          const title = item?.[field];

          return (
            <TableCell
              key={title || index}
              align="left"
              sx={{
                backgroundColor: '#fcfafa'
              }}
            >
              {title || ""}
            </TableCell>
          )
        })}
      </TableRow>
    )
  }

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '& > *': {
            borderBottom: 'unset'
          }
        }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        {headColumns.map(renderBodyTableCellHeader)}
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 10, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {bodyColumns.map(renderColumnsTableCellBody)}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {bodyData.map(renderBodyTableCellBody)}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleMaterialTable(props) {
  const {
    headColumns = [],
    bodyColumns = [],
    bodyData = [],
    mainListKey = "calledsList",
    allOpened = false
  } = props;


  const _headColumns = headColumns || [];
  const _bodyColumns = bodyColumns || [];
  const _bodyData = bodyData || [];

  function renderColumnsTableCellHeader(item, index) {
    return (
      <TableCell sx={commonHeaderStyle} key={index} align="center">{item?.title || ""}</TableCell>
    )
  }

  return (
    <Grid container spacing={0} >
      <Grid item xs={12} sm={12} style={{ display: 'table', tableLayout: 'fixed', width: '100%', minWidth: '210px', paddingLeft: 0, paddingRight: 0 }}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead sx={{
              backgroundColor: '#f9f9f9',
              fontWeight: 'bold',
              borderBottom: '2px solid #b3b3b3'
            }}>
              <TableRow>
                <TableCell sx={commonHeaderStyle} />
                {_headColumns.map(renderColumnsTableCellHeader)}
              </TableRow>
            </TableHead>

            <TableBody>
              {_bodyData.map((data, index) => {
                const _data = data?.[mainListKey] || [];

                return (
                  <Row
                    key={index}
                    headColumns={_headColumns}
                    bodyColumns={_bodyColumns}
                    bodyData={_data}
                    allOpened={allOpened}
                    {...data}
                  />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>

        {_bodyData.length === 0 &&
          <Grid container spacing={2} mt={2} mb={2} justifyContent="center" alignItems="center">
            <Typography
              gutterBottom
              component="div"
            >
              <FormattedMessage id="rows.show" />
            </Typography>
          </Grid>
        }
      </Grid>
    </Grid>
  );
}

const defaultPropsType = {
  headColumns: PropTypes.array.isRequired,
  bodyColumns: PropTypes.array.isRequired,
  bodyData: PropTypes.array.isRequired
}

CollapsibleMaterialTable.propTypes = defaultPropsType;

Row.propTypes = {
  ...defaultPropsType,
  allOpened: PropTypes.bool
};
